/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Divider, Row, Table } from "antd";
import * as XLSX from "xlsx";
import ReactPaginate from "react-paginate";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
const $ = require("jquery");
$.Datatable = require("datatables.net");
const DepositReport = () => {
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyMobile, setCompanyMobile] = useState("");
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [user, setUser] = useState();
  
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  
  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  
  useEffect(() => {
    axios.get(baseUrl + "settings/data", {}).then((res) => {
      setCompanyName(res.data.CompanyName);
      setCompanyMobile(res.data.CompanyMobile);
      setCompanyAddress(res.data.CompanyAddress);
    });
  }, []);
  
  //use for pagination..
  let [limit,setLimit] = useState(1); // Default limit small to show invoice style correctly or 10000 based on requirement? Reverted to 10 for pagination visual but user had 10000. Sticking to manageable UI default.
  const setpageLimit = (event)=>{
    let key = event.target.value
    setLimit(key);
}
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [values, setValues] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);
  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };
  const profle = () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .get(
        baseUrl +
          `txn/depositreports/all?page=${pageNumber}&_limit=${limit}&FROM_DATE=${values[0]}&TO_DATE=${values[1]}`,
        { headers }
      )
      .then((res) => {
        setUser(res.data.datefind);
        setNumberOfPages(res.data.totalPages);
      });
  };
  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return newDate;
  };
  useEffect(() => {
    profle();
  }, [pageNumber, limit, values]);
  if (user === undefined) {
    return null;
  }
  const Print = () => {
    let printContents = document.getElementById(`printablediv`).innerHTML;
    let originalContents = document.body.innerHTML; // Fixed: store innerHTML string, not element ref
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents; 
    window.location.reload(); // Reload to restore event listeners destroyed by innerHTML replacement
  };
  const createDownloadData = () => {
    handleExport();
  };
  const handleExport = () => {
    let table1 = [
      {
        A: "Id",
        B: "UserName",
        C: "PhoneNumber",
        D: "Deposit Amount",
        E: "Deposit Status",
      },
    ];
    user.forEach((row) => {
      const userDetails = row;
      table1.push({
        A: userDetails._id,
        B: userDetails.User_id ? userDetails.User_id.Name : "",
        C: userDetails.User_id ? userDetails.User_id.Phone : "",
        D: userDetails.amount ? userDetails.amount : "",
        E: userDetails.status ? userDetails.status : "",
      });
    });
    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true,
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    XLSX.writeFile(wb, "DepositReport.xlsx");
  };
  // Styles
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
    
    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; display: flex; justify-content: space-between; align-items: center; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
    /* Controls */
    .controls-bar { display: flex; gap: 10px; flex-wrap: wrap; padding: 20px; background: #fafafa; border-bottom: 1px solid #eee; align-items: center; }
    
    .btn-custom { border: none; padding: 8px 16px; border-radius: 8px; font-weight: 600; cursor: pointer; transition: 0.2s; color: white; margin-right: 5px; }
    .btn-export { background: #27ae60; }
    .btn-export:hover { background: #219150; }
    .btn-print { background: #57155a; }
    .btn-print:hover { background: #3a0d3c; }
    .select-custom { padding: 8px 12px; border: 1px solid #ddd; border-radius: 6px; outline: none; background: white; }
    .rmdp-input { border: 1px solid #ddd; padding: 8px; border-radius: 6px; text-align: center; width: 220px; }
    /* Invoice Style */
    .invoice-container { background: white; padding: 20px; margin-bottom: 20px; border: 1px solid #eee; border-radius: 8px; }
    .invoice-header { display: flex; justify-content: space-between; margin-bottom: 20px; }
    .invoice-title { font-size: 1.2rem; font-weight: bold; color: #333; }
    
    /* Pagination */
    .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
    .page-item { display: inline-block; }
    .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
    .active .page-link { background: #57155a; color: white !important; border-color: #57155a; }
    /* Ant Table Override */
    .ant-table-thead > tr > th { background: #f8f9fa !important; color: #555; font-weight: 700; }
  `;
  return (
    <div className="admin-mgmt-page">
      <style>{styles}</style>
      
      <div className="row">
        <div className="col-12">
          <div className="modern-card">
            
            <div className="card-header-custom">
                <h4 className="card-title-custom">Deposit Invoice Reports</h4>
                
                <div>
                  <button onClick={createDownloadData} className="btn-custom btn-export">
                    <i className="mdi mdi-download mr-1"></i> Export Data
                  </button>
                  <button onClick={Print} className="btn-custom btn-print">
                    <i className="mdi mdi-printer mr-1"></i> Print All
                  </button>
                </div>
            </div>
            <div className="controls-bar">
                 <DatePicker 
                    value={values} 
                    onChange={setValues} 
                    range 
                    inputClass="rmdp-input"
                 />
                 
                 <select className='select-custom' id='pagelimit' name='pagelimit' onChange={setpageLimit}>
                      <option value="10">10 Invoices</option>
                      <option value="20">20 Invoices</option>
                      <option value="50">50 Invoices</option>
                      <option value="100">100 Invoices</option>
                      <option value="500">500 Invoices</option>
                 </select>
            </div>
              <div className="table-responsive" style={{ background: '#f4f7f6', padding: '20px' }}>
                <div id="printablediv">
                  {user &&
                    user.map((data, key) =>{ 
                      var id          = data._id.toString();
                      // Logic preserved from original code
                      var timestamp   = id.slice(0, 8);
                      var counterid   = parseInt(timestamp, 16); 
                      
                      return(
                      
                      <div className="invoice-container" key={key} style={{pageBreakAfter: 'always'}}>
                        <Row>
                          <Col span={24}>
                            <Divider style={{borderColor: '#57155a', color:'#57155a', fontWeight:'bold'}}>INVOICE</Divider>
                          </Col>
                        </Row>
                        <Row gutter={24} style={{ marginTop: 10 }}>
                          <Col span={12}>
                            <h3 style={{color: '#333', fontWeight:'bold'}}>{CompanyName}</h3>
                            <div style={{color: '#555'}}>{CompanyAddress}</div>
                            <div style={{color: '#555'}}>GSTIN : -</div>
                            <div style={{color: '#555'}}>MOB: {CompanyMobile}</div>
                          </Col>
                          <Col span={12} style={{textAlign: 'right'}}>
                            <table style={{float:'right'}}>
                              <tbody>
                                <tr>
                                  <th style={{paddingRight:'10px'}}>Date:</th>
                                  <td>{dateFormat(data.createdAt).split(",")[0]}</td>
                                </tr>
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 30 }}>
                          <div>
                            <strong>Bill To:</strong>
                            <h5 style={{marginTop:'5px', fontWeight:'700', color:'#57155a'}}>
                              {(data.User_id && data.User_id.holder_name) ? data.User_id.holder_name : (data.User_id ? data.User_id.Name : 'Unknown')}
                            </h5>
                            <div>
                                {data.User_id ? data.User_id.Phone : ""}
                            </div>
                          </div>
                        </Row>
                        <Row style={{ marginTop: 20 }}>
                          <Col span={24}>
                            <Table
                                dataSource={[
                                {
                                    key: 1,
                                    name: "Deposit",
                                    price: `${data.amount ? "Rs. "+data.amount : ""}`,
                                    ID: `JP-${counterid}`,
                                    TxnID: `${data.order_token}`,
                                    paymentType: `UPI`,
                                    paymentGatway: `${data.payment_gatway}`,
                                },
                                ]}
                                pagination={false}
                                bordered
                            >
                                <Table.Column title="Description" dataIndex="name"/>
                                <Table.Column title="Amount" dataIndex="price" />
                                <Table.Column title="Order ID" dataIndex="ID" />
                                <Table.Column title="Txn ID" dataIndex="TxnID" />
                                <Table.Column title="Payment Type" dataIndex="paymentType" />
                                <Table.Column title="Gateway" dataIndex="paymentGatway" />
                            </Table>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 20 }}>
                          <Col span={8} offset={16}>
                             <div style={{background:'#fafafa', padding:'15px', borderRadius:'8px', textAlign:'right'}}>
                                <span style={{fontWeight:'bold', marginRight:'10px'}}>Total Amount:</span>
                                <span style={{fontSize:'1.1rem', color:'#27ae60', fontWeight:'bold'}}>{data.amount ? "Rs. " + data.amount : ""}</span>
                             </div>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 40, textAlign: "center", color: '#999', fontSize: '0.8rem' }}>
                          <Col span={24}>
                            ---- THIS IS A COMPUTER GENERATED INVOICE NO SIGNATURE REQUIRED ----
                          </Col>
                        </Row>
                      </div>
                    )})}
                </div>
              </div>
              <div className="p-3">
                <ReactPaginate
                  previousLabel={"← Prev"}
                  nextLabel={"Next →"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DepositReport;